import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../lib/LangContext";
import { SITE } from "../lib/siteContent";

export default function SiteNav() {
    const { lang, setLang } = useLang();
    const n = SITE.nav[lang];

    const items = [
        { id: "announcement", label: n.announcement },
        { id: "origins", label: n.origins },
        { id: "evolution", label: n.evolution },
        { id: "editions", label: n.editions },
        { id: "salt", label: n.salt },
        { id: "honey", label: n.honey },
        { id: "follow", label: n.follow },
        { id: "circle", label: n.circle },
    ];

    const goto = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <motion.nav
            data-testid="site-navigation"
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 2.4, duration: 0.9, ease: [0.7, 0, 0.2, 1] }}
            className="fixed top-0 left-0 right-0 z-40 no-print"
            style={{ background: "rgba(244,239,230,0.86)", backdropFilter: "blur(10px)" }}
        >
            <div className="flex items-center justify-between px-6 md:px-10 py-4 md:py-5">
                <a href="/" className="font-didone text-lg md:text-xl" style={{ letterSpacing: "0.14em" }} aria-label="Intollerantia home">
                    <span>I</span>
                    <span className="inline-block" style={{ transform: "scaleX(-1)" }}>R</span>
                </a>

                <div className="hidden lg:flex items-center gap-8 font-micro text-[10px]" style={{ letterSpacing: "0.32em" }}>
                    {items.map((it) => (
                        <button
                            key={it.id}
                            data-testid={`site-nav-${it.id}`}
                            onClick={() => goto(it.id)}
                            className="link-ed"
                        >
                            {it.label.toUpperCase()}
                        </button>
                    ))}
                </div>

                <div className="flex items-center gap-5">
                    <div data-testid="site-lang-toggle" className="flex items-center gap-2 font-micro text-[10px]">
                        <button
                            data-testid="site-lang-en"
                            onClick={() => setLang("en")}
                            className={`link-ed ${lang === "en" ? "" : "opacity-40"}`}
                        >
                            EN
                        </button>
                        <span className="opacity-40">·</span>
                        <button
                            data-testid="site-lang-it"
                            onClick={() => setLang("it")}
                            className={`link-ed ${lang === "it" ? "" : "opacity-40"}`}
                        >
                            IT
                        </button>
                    </div>
                </div>
            </div>
            <div className="h-px w-full" style={{ background: "#C9A96A", opacity: 0.4 }} />
        </motion.nav>
    );
}
